import Datepicker from 'theme/Datepicker/Datepicker'
import React from 'react'
import HelperDate from 'utils/helper-date'

const ThemedDatepicker = ({ onSelect, date, accessoryRight, max = false, min = false, style = {} }) => {
	
	const viewStyle = style
	
	const defaultMaxMinYears = 100
	
	max = (max === false) ? HelperDate.date().add( defaultMaxMinYears, 'years').endOf('year' ).toDate() : max
	min = (min === false) ? HelperDate.date().subtract( defaultMaxMinYears, 'years').endOf('year' ).toDate() : min
	
	return (
		<Datepicker
			style={ viewStyle }
			accessoryRight={ accessoryRight }
			date={ date }
			onSelect={ onSelect }
			min={ min }
			max={ max }
		/>
	)
}

export default ThemedDatepicker
